import { getSessionState, syncSessionStore, clearSessionStore } from '@/stores/sessionStore'

const AUTH_ROLES = ['Discover', 'Premium', 'Teacher', 'Admin']
const REFRESH_INTERVAL_MS = 10 * 1000

const state = getSessionState()

let refreshIntervalId = null

function deriveUserRole(keycloak = state.keycloak) {
  if (!keycloak) return 'Invité'
  if (keycloak.hasRealmRole?.('Admin')) return 'Admin'
  if (keycloak.hasRealmRole?.('Teacher')) return 'Teacher'
  if (keycloak.hasRealmRole?.('Premium')) return 'Premium'
  if (keycloak.hasRealmRole?.('Discover')) return 'Discover'
  return 'Invité'
}

function syncState() {
  syncSessionStore({
    authenticated: !!state.keycloak?.authenticated,
    userRole: deriveUserRole(),
    initialized: state.initialized,
    keycloak: state.keycloak
  })
}

function resetLocalState() {
  clearSessionStore()
  syncSessionStore({
    initialized: state.initialized,
    keycloak: state.keycloak
  })
}

function stopRefreshLoop() {
  if (refreshIntervalId) {
    window.clearInterval(refreshIntervalId)
    refreshIntervalId = null
  }
}

function startRefreshLoop() {
  stopRefreshLoop()

  if (!state.authenticated || !state.keycloak) return

  refreshIntervalId = window.setInterval(async () => {
    try {
      await state.keycloak.updateToken(30)
      syncState()
    } catch (error) {
      stopRefreshLoop()
      resetLocalState()
    }
  }, REFRESH_INTERVAL_MS)
}

export function registerKeycloak(keycloak) {
  syncSessionStore({
    keycloak,
    initialized: true
  })
  syncState()
  startRefreshLoop()
}

export async function ensureFreshToken(minValidity = 70) {
  if (!state.keycloak?.authenticated) {
    syncState()
    return false
  }

  await state.keycloak.updateToken(minValidity)
  syncState()
  return true
}

export async function requireAuthenticatedRoute(to) {
  const requiresAuth = to.matched.some((record) => record.meta?.isAuthenticated)
  if (!requiresAuth) return { allowed: true }

  if (!state.keycloak?.authenticated) {
    const redirectUri = `${window.location.origin}${to.fullPath || '/app'}`
    await state.keycloak?.login?.({ redirectUri })
    return { allowed: false }
  }

  await ensureFreshToken(70)

  if (AUTH_ROLES.includes(state.userRole)) {
    return { allowed: true }
  }

  if (state.keycloak?.authenticated) {
    return { allowed: false, redirectTo: '/acces-refuse' }
  }
  return { allowed: false, redirectTo: '/' }
}

export async function logout({ redirectUri } = {}) {
  const target = redirectUri || `${window.location.origin}/`
  stopRefreshLoop()
  resetLocalState()

  if (state.keycloak?.logout) {
    await state.keycloak.logout({ redirectUri: target })
  }
}

export function refreshSessionUserId() {
  syncSessionStore()
}

export function getAuthState() {
  return state
}

export function getKeycloakInstance() {
  return state.keycloak
}

export function getCurrentUserRole() {
  return state.userRole
}

export function getCurrentUserId() {
  return state.userId
}

export function isAuthenticated() {
  return state.authenticated
}
